module.exports = __webpack_public_path__ + "img/rightReceived_zh-HK.8f61be75.png";